// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"194":"77441033","363":"2b38ae07"}[chunkId] + ".chunk.css";
};